export const shapes: string[] = ["Round", "Square", "Circle"];
